import withAPIAction from 'helpers/withAPIAction'
import {
  SaleOrderCustomerListReq,
  CreateSaleOrderCustomerReq,
  UpdateSaleOrderCustomerReq,
  DeleteSaleOrderCustomerReq,
  SaleOrderCustomerDetailReq,
  SaleOrderListReq,
} from './types'
import {
  getSaleOrderCustomerListAction,
  createSaleOrderCustomerAction,
  updateSaleOrderCustomerAction,
  deleteSaleOrderCustomerAction,
  getSaleOrderCustomerDetailAction,
  getAllSaleOrderCustomerListAction,
  getSaleOrderListAction,
} from './actions'
import { APIPath } from 'services/APIPath'
import { appConfig } from 'config'
import { getRequestString } from 'helpers/format'

export const customerListAPI = (data: SaleOrderCustomerListReq, token: string, xmid: string) => {
  return withAPIAction<SaleOrderCustomerListReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    // path: `${APIPath.customerList}?${getRequestString(data)}`,
    path: `${APIPath.customerList}`,
    data,
    token,
    xmid,
    // hideOath: true,
  })(getSaleOrderCustomerListAction)
}

export const allSaleOrderCustomerListAPI = (data: SaleOrderCustomerListReq, token: string, xmid: string) => {
  return withAPIAction<SaleOrderCustomerListReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    // path: `${APIPath.customerList}?${getRequestString(data)}`,
    path: `${APIPath.customerList}`,
    data,
    token,
    xmid,
    // hideOath: true,
  })(getAllSaleOrderCustomerListAction)
}

export const createSaleOrderCustomerAPI = (data: CreateSaleOrderCustomerReq, token: string, xmid: string) => {
  return withAPIAction<CreateSaleOrderCustomerReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.createCustomer,
    data,
    token,
    xmid,
  })(createSaleOrderCustomerAction)
}

export const updateSaleOrderCustomerAPI = (data: UpdateSaleOrderCustomerReq, token: string, xmid: string) => {
  const endPoint = APIPath.updatCustomer.replace(':id', data.id.toString())
  return withAPIAction<UpdateSaleOrderCustomerReq>({
    method: 'PUT',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(updateSaleOrderCustomerAction)
}

export const deleteSaleOrderCustomerAPI = (data: DeleteSaleOrderCustomerReq, token: string, xmid: string) => {
  return withAPIAction<DeleteSaleOrderCustomerReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.deleteCustomer,
    data,
    token,
    xmid,
  })(deleteSaleOrderCustomerAction)
}

export const getSaleOrderCustomerDetailAPI = (
  data: SaleOrderCustomerDetailReq,
  token: string,
  xmid: string,
) => {
  const endPoint = APIPath.getCustomerByID.replace(':id', data.id.toString())
  return withAPIAction<SaleOrderCustomerDetailReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(getSaleOrderCustomerDetailAction)
}

export const getSaleOrderListAPI = (data: SaleOrderListReq, token: string, xmid: string) => {
  const endPoint = APIPath.saleOrderList.replace(':id', data.id.toString())
  return withAPIAction<SaleOrderListReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(getSaleOrderListAction)
}
